export default __webpack_public_path__ + "static/media/5.83407681.mp3";